<div class="trh-page">
  <app-project-nav></app-project-nav>

  @if (loading()) {
    <div class="trh-state">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>
  } @else if (loadError()) {
    <div class="trh-state trh-state--error">{{ 'testResults.history.loadError' | translate }}</div>
  } @else {
    <div class="trh-header">
      <div>
        <div class="trh-eyebrow">{{ 'testResults.history.eyebrow' | translate }}</div>
        <div class="trh-title-row">
          <h1 class="trh-title">{{ 'testResults.history.title' | translate }}</h1>
          @if (testCaseKey()) {
            <code class="trh-tc-key">{{ testCaseKey() }}</code>
          }
        </div>
        <p class="trh-subtitle">
          @if (title()) {
            {{ title() }} · {{ 'testResults.history.subtitle' | translate }}
          } @else {
            {{ 'testResults.history.subtitle' | translate }}
          }
        </p>
      </div>
      <a class="trh-back" [routerLink]="overviewLink" [queryParams]="overviewQueryParams">
        <mat-icon aria-hidden="true">chevron_left</mat-icon>
        {{ 'testResults.history.backToOverview' | translate }}
      </a>
    </div>

    <div class="trh-kpis">
      <div class="trh-kpi">
        <div class="trh-kpi-icon trh-kpi-icon--neutral"><mat-icon>bar_chart</mat-icon></div>
        <div class="trh-kpi-label">{{ 'testResults.history.kpi.total' | translate }}</div>
        <div class="trh-kpi-value">{{ total() }}</div>
      </div>
      <div class="trh-kpi">
        <div class="trh-kpi-icon trh-kpi-icon--{{ passRateClass() }}"><mat-icon>check_circle</mat-icon></div>
        <div class="trh-kpi-label">{{ 'testResults.history.kpi.passRate' | translate }}</div>
        <div class="trh-kpi-value trh-kpi-value--{{ passRateClass() }}">{{ passRate() }}%</div>
      </div>
      <div class="trh-kpi">
        <div class="trh-kpi-icon trh-kpi-icon--failed"><mat-icon>close</mat-icon></div>
        <div class="trh-kpi-label">{{ 'testResults.history.kpi.failed' | translate }}</div>
        <div class="trh-kpi-value trh-kpi-value--failed">{{ failed() }}</div>
      </div>
      <div class="trh-kpi">
        <div class="trh-kpi-icon trh-kpi-icon--neutral"><mat-icon>timer</mat-icon></div>
        <div class="trh-kpi-label">{{ 'testResults.history.kpi.avgDuration' | translate }}</div>
        <div class="trh-kpi-value">{{ avgDuration() }}</div>
      </div>
    </div>

    @if (total() > 0) {
      <div class="trh-spark-card">
        <span class="trh-spark-label">{{ 'testResults.history.trend' | translate }}</span>
        <div class="trh-spark">
          @for (entry of sparkline(); track entry.runId) {
            <a
              class="trh-matrix-cell trh-matrix-cell--{{ statusKey(entry.status) }}"
              [routerLink]="detailLink(entry)"
              [title]="entry.runKey"
              [attr.aria-label]="entry.runKey"
            >
              <mat-icon>{{ matrixIcon(entry.status) }}</mat-icon>
            </a>
          }
        </div>
        <span class="trh-spark-hint">{{ 'testResults.history.oldToNew' | translate }}</span>
      </div>
    }

    <div class="trh-table-card">
      <div class="trh-table-head">
        <div class="trh-col-run">{{ 'testResults.history.table.run' | translate }}</div>
        <div class="trh-col-when">{{ 'testResults.history.table.timestamp' | translate }}</div>
        <div class="trh-col-status">{{ 'testResults.history.table.status' | translate }}</div>
        <div class="trh-col-duration">{{ 'testResults.history.table.duration' | translate }}</div>
        <div class="trh-col-env">{{ 'testResults.history.table.environment' | translate }}</div>
        <div class="trh-col-system">{{ 'testResults.history.table.source' | translate }}</div>
        <div class="trh-col-user">{{ 'testResults.history.table.executedBy' | translate }}</div>
        <div class="trh-col-chevron"></div>
      </div>

      @if (total() === 0) {
        <div class="trh-empty">{{ 'testResults.history.empty' | translate }}</div>
      }

      @for (entry of entries(); track entry.runId) {
        <a class="trh-row" [routerLink]="detailLink(entry)">
          <div class="trh-col-run">
            <code class="trh-tc-key">{{ entry.runKey }}</code>
          </div>
          <div class="trh-col-when">
            {{ entry.completedAt ? (entry.completedAt | date: "dd.MM.yyyy '·' HH:mm") : '—' }}
          </div>
          <div class="trh-col-status">
            <span class="trh-pill trh-pill--{{ statusKey(entry.status) }}">
              <span class="trh-pill-dot"></span>
              {{ 'testResults.result.' + statusKey(entry.status) | translate }}
            </span>
          </div>
          <div class="trh-col-duration">{{ formatDuration(entry.durationSeconds) }}</div>
          <div class="trh-col-env">
            @if (entry.environment) {
              <span class="trh-env-pill trh-env-pill--{{ environmentClass(entry.environment) }}">
                {{ entry.environment }}
              </span>
            } @else {
              <span class="trh-env-empty">—</span>
            }
          </div>
          <div class="trh-col-system">
            <span class="trh-badge">
              <span class="trh-badge-glyph trh-badge-glyph--{{ sourceToSystemKey(entry.source) }}">
                {{ systemMeta(sourceToSystemKey(entry.source)).glyph }}
              </span>
              <span class="trh-badge-label">
                {{ systemMeta(sourceToSystemKey(entry.source)).labelKey | translate }}
              </span>
            </span>
          </div>
          <div class="trh-col-user">{{ entry.executedByName || '—' }}</div>
          <div class="trh-col-chevron"><mat-icon>chevron_right</mat-icon></div>
        </a>
      }
    </div>
  }
</div>
